import API from './API';
import URLSearchParams from 'url-search-params';
import LocationActions from 'actions/LocationActions';

const EARTH_URL = "http://img.xiaodiqiu.cn/image/earth.png";
const LocationSource = {
  getLocation: {
    remote(state){
      let fetchUrl, resultType;
      let type = state.type;
      let id = state.location_id;
      if(type === 'world') {
        return;
      } else if(type === 'continent') {
        fetchUrl = API.getContinentDetail;
        resultType = 'continent';
      } else if(type === 'country') {
        fetchUrl = API.getCountryDetail;
        resultType = 'country';
      } else if(type === 'state') {
        fetchUrl = API.getStateDetail;
        resultType = 'state';
      } else if(type === 'city'){
        fetchUrl = API.getCityDetail;
        resultType = 'city';      
      }
      return fetch(`${fetchUrl}`.replace(':id',id)).then(response => response.json()).then(json=>{
        json.result.type = resultType;
        return json;
      });
    },
    shouldFetch() {
      return true;
    },
    success: LocationActions.fetchDetailSuccess,
    error: LocationActions.fetchFailed
  },

  getRemoteLocation: {
    remote(state) {
      let fetchUrl, resultType;
      let sendData = {
        first: state.first,
        maxCount: state.maxCount
      };
      if(state.location.type === 'world') {
        fetchUrl = API.getContinentList;
        resultType = 'continent';
      } else if(state.location.type === 'continent') {
        fetchUrl = API.getCountryList;
        resultType = 'country';
        sendData.continent_id = state.location._id;
      } else if(state.location.type === 'country') {
        fetchUrl = API.getStateList;
        resultType = 'state';
        sendData.country_id = state.location._id;
      } else if(state.location.type === 'state') {
        fetchUrl = API.getCityList;
        resultType = 'city';
        sendData.state_id = state.location._id;
      } else if(state.location.type === 'city'){
        return;
      } 

      let searchParams = new URLSearchParams();
      for(let k in sendData) {
        if(sendData[k] === 0 || sendData[k]) {
          searchParams.append(k, sendData[k]);
        }
      }
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json()).then(json=>{
        json.result.forEach((item, index)=>{
          json.result[index].type = resultType;
        });
        if(resultType === 'continent') {
          json.result.push({name: '小地球', _id: '0000', type:'world', image: EARTH_URL});
        } else if(json.result.length === 8) {
          json.result = json.result.slice(0, 7);
          json.result.push({
            name: '更多',
            _id: 'FFFF',
            type:'more',
            image: EARTH_URL,
            location: state.location
          });
        }
        return json;
      });
    },
    shouldFetch(state) {
      if (state.location.type === 'city') return false;
      return true;
    },
    success: LocationActions.fetchSuccess,
    error: LocationActions.fetchFailed
  },

  getAllRemoteLocation: {
    remote(state) {
      let fetchUrl, resultType;
      let sendData = {
        first: 0,
        maxCount: 300
      };
      if(state.location.type === 'continent') {
        fetchUrl = API.getCountryList;
        resultType = 'country';
        sendData.continent_id = state.location._id;
      } else if(state.location.type === 'country') {
        fetchUrl = API.getStateList;
        resultType = 'state';
        sendData.country_id = state.location._id;
      } else if(state.location.type === 'state') {
        fetchUrl = API.getCityList;
        resultType = 'city';
        sendData.state_id = state.location._id;
      }
      let searchParams = new URLSearchParams();
      for(let k in sendData) {
        if(sendData[k] === 0 || sendData[k]) {
          searchParams.append(k, sendData[k]);
        }
      }
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json()).then(json=>{
        json.result.forEach((item, index)=>{
          json.result[index].type = resultType;
        });
        return json;
      });
    },
    shouldFetch() {
      return true;
    },
    success: LocationActions.fetchAllSuccess,
    error: LocationActions.fetchFailed
  }
};

export default LocationSource;



// WEBPACK FOOTER //
// ./src/sources/LocationSource.js